// extracted by mini-css-extract-plugin
export default {"input":"TextAnswerGroup_input__1OR+3","inputLight":"TextAnswerGroup_inputLight__h7g2M","inputDark":"TextAnswerGroup_inputDark__rgNey"};